export default __webpack_public_path__ + "static/media/Ballagameslogoicon 1.4eb02044.svg";